import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import IconSidebarClose from 'components/icons/IconSidebarClose';
import notificationBannerHelper from 'components/consumer/NotificationBanner/utils';
import useScreen from 'hooks/useScreen';
import FBSignup from '../fb-signup';
import PreLogin from '../pre-login';
import LoginForm from '../login-form';
import CreatePassword from '../create-password';
const LoginContainer = t0 => {
  const $ = _c(74);
  const {
    initialState: t1,
    isLoginPage: t2,
    noPadding: t3,
    onClose,
    onGuestLoginClick: t4,
    onLogin,
    showClose: t5,
    showGuestLogin: t6,
    showNotificationOnLogin: t7,
    staticContext,
    variant,
    wishListProduct: t8
  } = t0;
  let t9;
  if ($[0] !== t1) {
    t9 = t1 === undefined ? {
      email: "",
      showLogin: false,
      showSignUp: false,
      showFBSignUp: false,
      showResetPassword: false,
      showCreatePassword: false
    } : t1;
    $[0] = t1;
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  const initialState = t9;
  const isLoginPage = t2 === undefined ? false : t2;
  const noPadding = t3 === undefined ? false : t3;
  const onGuestLoginClick = t4 === undefined ? _temp : t4;
  const showClose = t5 === undefined ? false : t5;
  const showGuestLogin = t6 === undefined ? false : t6;
  const showNotificationOnLogin = t7 === undefined ? true : t7;
  const wishListProduct = t8 === undefined ? null : t8;
  const {
    isMobile
  } = useScreen();
  const [state, setState] = useState(initialState);
  let t10;
  if ($[2] !== onLogin || $[3] !== showNotificationOnLogin || $[4] !== wishListProduct) {
    t10 = (user, wishListProductName) => {
      const hasWishListProduct = !!(wishListProduct || wishListProductName);
      if (showNotificationOnLogin && (!user.is_designer || hasWishListProduct)) {
        setTimeout(() => {
          notificationBannerHelper.showMsg("login", {
            firstName: user.first_name,
            wishListProduct: wishListProduct || wishListProductName
          });
        }, hasWishListProduct ? 500 : 0);
      }
      if (typeof onLogin === "function") {
        onLogin(user);
      }
    };
    $[2] = onLogin;
    $[3] = showNotificationOnLogin;
    $[4] = wishListProduct;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  let t11;
  if ($[6] !== isMobile || $[7] !== onClose || $[8] !== onLogin || $[9] !== wishListProduct) {
    t11 = user_0 => {
      notificationBannerHelper.showMsg("signup", {
        firstName: user_0.first_name,
        wishListProduct
      });
      if (!isMobile && onClose) {
        setTimeout(() => {
          onClose();
        }, 100);
      }
      if (typeof onLogin === "function") {
        onLogin(user_0);
      }
    };
    $[6] = isMobile;
    $[7] = onClose;
    $[8] = onLogin;
    $[9] = wishListProduct;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  if ($[11] !== state) {
    t12 = () => {
      setState({
        ...state,
        showLogin: true,
        showSignUp: false,
        showFBSignUp: false,
        showResetPassword: true,
        showCreatePassword: false
      });
    };
    t13 = () => {
      setState({
        ...state,
        showLogin: true,
        showSignUp: false,
        showFBSignUp: false
      });
    };
    t14 = evt => {
      setState({
        ...state,
        email: evt.target.value
      });
    };
    t15 = evt_0 => {
      setState({
        ...state,
        password: evt_0.target.value
      });
    };
    t16 = evt_1 => {
      setState({
        ...state,
        first_name: evt_1.target.value
      });
    };
    t17 = evt_2 => {
      setState({
        ...state,
        last_name: evt_2.target.value
      });
    };
    t18 = fbLoginData => {
      if (fbLoginData && fbLoginData.name && fbLoginData.email) {
        let [first_name, last_name] = fbLoginData.name.split(" ");
        first_name = first_name || fbLoginData.name;
        last_name = last_name || fbLoginData.name;
        setState({
          ...state,
          email: fbLoginData.email,
          first_name,
          last_name,
          fbLoginData,
          showLogin: false,
          showSignUp: false,
          showFBSignUp: true,
          showResetPassword: false,
          showCreatePassword: false
        });
      }
    };
    t19 = exists => {
      if (exists) {
        setState({
          ...state,
          showLogin: true,
          showSignUp: false,
          showFBSignUp: false,
          showResetPassword: false,
          showCreatePassword: false
        });
      } else {
        setState({
          ...state,
          showLogin: false,
          showSignUp: true,
          showFBSignUp: false,
          showResetPassword: false,
          showCreatePassword: false
        });
      }
    };
    $[11] = state;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
    $[16] = t16;
    $[17] = t17;
    $[18] = t18;
    $[19] = t19;
  } else {
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
    t15 = $[15];
    t16 = $[16];
    t17 = $[17];
    t18 = $[18];
    t19 = $[19];
  }
  let t20;
  if ($[20] !== onClose || $[21] !== t10 || $[22] !== t11 || $[23] !== t12 || $[24] !== t13 || $[25] !== t14 || $[26] !== t15 || $[27] !== t16 || $[28] !== t17 || $[29] !== t18 || $[30] !== t19) {
    t20 = {
      onClose,
      onLogin: t10,
      onSignUp: t11,
      onForgotPasswordClick: _temp2,
      onForgotPasswordSuccess: _temp3,
      showResetPassword: t12,
      onLoginClick: t13,
      onEmailChange: t14,
      onPasswordChange: t15,
      onFirstNameChange: t16,
      onLastNameChange: t17,
      onFBCallback: t18,
      onCustomerExistsUpdate: t19
    };
    $[20] = onClose;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
    $[29] = t18;
    $[30] = t19;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  const actions = t20;
  let t21;
  if ($[32] !== noPadding) {
    t21 = classNames("md:px-[1.625rem] md:py-0 md:w-[27.625rem]", {
      "md:!p-0 md:!w-auto": noPadding
    });
    $[32] = noPadding;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== isMobile || $[35] !== onClose || $[36] !== showClose) {
    t22 = showClose && !isMobile && <div className="relative max-[767px]:p-0"><IconSidebarClose style={{
        position: "absolute",
        right: "1rem",
        top: "1rem"
      }} onClick={onClose} /></div>;
    $[34] = isMobile;
    $[35] = onClose;
    $[36] = showClose;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  const t23 = !noPadding;
  const t24 = variant === "login-page" || variant === "reset-password";
  let t25;
  if ($[38] !== noPadding || $[39] !== t23 || $[40] !== t24) {
    t25 = classNames("px-0 pb-0", {
      "pt-[5.125rem] max-[767px]:[border-top:1px_solid_#f1f1f1] max-[767px]:min-h-[calc(100vh_-_60px)] max-[767px]:px-5 max-[767px]:py-9": t23,
      "pt-4 max-[767px]:[border-top:0] max-[767px]:min-h-[auto] max-[767px]:!p-0": noPadding,
      "md:!px-0 md:!py-12": t24
    });
    $[38] = noPadding;
    $[39] = t23;
    $[40] = t24;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== actions || $[43] !== isLoginPage || $[44] !== isMobile || $[45] !== onGuestLoginClick || $[46] !== showGuestLogin || $[47] !== state || $[48] !== staticContext) {
    t26 = !state.showLogin && !state.showSignUp && !state.showFBSignUp && !state.showResetPassword && !state.showCreatePassword && <PreLogin state={state} actions={actions} isLoginPage={isLoginPage} staticContext={staticContext} showGuestLogin={showGuestLogin} onGuestLoginClick={onGuestLoginClick} isMobile={isMobile} />;
    $[42] = actions;
    $[43] = isLoginPage;
    $[44] = isMobile;
    $[45] = onGuestLoginClick;
    $[46] = showGuestLogin;
    $[47] = state;
    $[48] = staticContext;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== actions || $[51] !== state) {
    t27 = state.showLogin && <LoginForm state={state} actions={actions} />;
    $[50] = actions;
    $[51] = state;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== actions || $[54] !== state) {
    t28 = state.showSignUp && <CreatePassword mode="signup" state={state} actions={actions} />;
    $[53] = actions;
    $[54] = state;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] !== actions || $[57] !== state) {
    t29 = state.showCreatePassword && <CreatePassword mode="forgot-password" state={state} actions={actions} />;
    $[56] = actions;
    $[57] = state;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] !== actions || $[60] !== state || $[61] !== staticContext) {
    t30 = state.showFBSignUp && <FBSignup state={state} actions={actions} staticContext={staticContext} />;
    $[59] = actions;
    $[60] = state;
    $[61] = staticContext;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  let t31;
  if ($[63] !== t25 || $[64] !== t26 || $[65] !== t27 || $[66] !== t28 || $[67] !== t29 || $[68] !== t30) {
    t31 = <div className={t25}>{t26}{t27}{t28}{t29}{t30}</div>;
    $[63] = t25;
    $[64] = t26;
    $[65] = t27;
    $[66] = t28;
    $[67] = t29;
    $[68] = t30;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] !== t21 || $[71] !== t22 || $[72] !== t31) {
    t32 = <div className={t21}>{t22}{t31}</div>;
    $[70] = t21;
    $[71] = t22;
    $[72] = t31;
    $[73] = t32;
  } else {
    t32 = $[73];
  }
  return t32;
};
LoginContainer.propTypes = {
  initialState: PropTypes.shape({
    email: PropTypes.string,
    showLogin: PropTypes.bool,
    showSignUp: PropTypes.bool,
    showFBSignUp: PropTypes.bool,
    showResetPassword: PropTypes.bool,
    showCreatePassword: PropTypes.bool
  }),
  isLoginPage: PropTypes.bool,
  noPadding: PropTypes.bool,
  onClose: PropTypes.func,
  onGuestLoginClick: PropTypes.func,
  onLogin: PropTypes.func,
  showClose: PropTypes.bool,
  showGuestLogin: PropTypes.bool,
  showNotificationOnLogin: PropTypes.bool,
  staticContext: PropTypes.shape({}),
  variant: PropTypes.oneOf(['login-page', 'reset-password']),
  wishListProduct: PropTypes.string
};
export default LoginContainer;
function _temp() {}
function _temp2(email) {
  notificationBannerHelper.showMsg("forgotPassword", {
    email
  });
}
function _temp3() {
  notificationBannerHelper.showMsg("forgotPassword", {
    isSuccess: true
  });
}